import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.css';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

//Components
import BannerCaption from '../../components/Home/BannerCaption';
import HomeSlider from '../../components/Home/HomeSlider';
import NewsBox from '../../components/Home/NewsBox';
import SearchForm from '../../components/Home/SearchForm';
import Layout1 from '../../components/Home/Layout1';
import Layout3 from '../../components/Home/Layout3';
import Layout4 from '../../components/Home/Layout4';

// Locale
import messages from '../../locale/messages';

//Images
import SearchBg from '../../../public/SiteImages/main-v2.png';

import { url } from '../../config';

class Homepage extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
  };

  render() {
    const { layoutType } = this.props;
    return (
      <div className={s.root}>
        {
          layoutType && layoutType == 2 ? <div className={s.searchFormBgSection}>
            <div className={s.searchFormBg} style={{ backgroundImage: `url(${SearchBg})` }} />
            <div className={s.container}>
              <SearchForm />
              <BannerCaption />
            </div>
          </div> : layoutType == 1 ? <Layout1 layoutType={layoutType} /> : layoutType == 3 ? <Layout3 layoutType={layoutType} /> : <Layout4 layoutType={layoutType} />
        }
        <div className={cx(s.pageContainer, s.container)}>
          <h3 className={s.containerTitle}>
            <FormattedMessage {...messages.nearByOfficesLabel} />
          </h3>
          <HomeSlider />
        </div>
        <div className={s.pageContainer}>
          <NewsBox />
        </div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
)(Homepage);


// WEBPACK FOOTER //
// src/routes/home/Home.js